import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';

export type GenderSelectItem = {
   id: number;
   value: Gender;
   name: string;
};
const genderSelectItems: GenderSelectItem[] = [
   {
      id: 0,
      name: 'Kobieta',
      value: 'WOMAN',
   },
   {
      id: 1,
      name: 'Mężczyzna',
      value: 'MAN',
   },
];

const useGenderLabelExtractor = (): ((item: GenderSelectItem | undefined) => string) => {
   const translate = useTranslate();
   return (item?: GenderSelectItem): string => {
      return item ? translate(`common:genderTypes:${item.value.toLowerCase()}`) : '';
   };
};

export { useGenderLabelExtractor, genderSelectItems };
